import { store } from "@/state/store";
import { pushEvent } from "@/services/dataLayerLogin";

export const switchLoginAndRegister = (buttonPosition: string) => {
	// Tracking (muss vor dem switch passieren, damit der Klick auf der aktuellen Form getrackt wird
	const trackingAction = buttonPosition === "Bottom" ? "SwitchForm_2" : "SwitchForm";
	pushEvent(trackingAction);

	// switch form
	store.isLogin = !store.isLogin;

	// focus for accessiblity
	document.getElementById("loginRegisterModalHeadlineId")?.focus();
};
